"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var DownloadStepContracts_1 = require("./DownloadStepContracts");
var DropdownStep_1 = __importDefault(require("./DropdownStep"));
var ProductDetailService_1 = require("../../services/ProductDetailService");
var GlobalStateContext_1 = require("../../utils/GlobalStateContext");
var ProductDropdownStep = function () {
    // global state context things
    var context = (0, react_1.useContext)(GlobalStateContext_1.GlobalStateContext);
    var state = context.state, setState = context.setState;
    var setProductNodeId = function (newProductNodeId) { return setState(function (prevState) { return (__assign(__assign({}, prevState), { productDetailNodeId: newProductNodeId, 
        // reset article states
        articleId: "", articleOptions: [state.pleaseSelectOption] })); }); };
    var setProductOptions = function (newProductOptions) { return setState(function (prevState) { return (__assign(__assign({}, prevState), { productDetailOptions: newProductOptions, productDetailOptionsFetchedFor: state.productGroupNodeId })); }); };
    // label text
    var _a = (0, react_1.useState)(''), labelText = _a[0], setLabelText = _a[1];
    var _b = (0, react_1.useState)(''), loadingText = _b[0], setLoadingText = _b[1];
    (0, react_1.useEffect)(function () {
        setLabelText(window.bes.spareparts.dropdown3text);
        setLoadingText(window.bes.spareparts.loadingtext);
    }, []);
    // states -------------------------------------------------------------------------------------
    var _c = (0, react_1.useState)(false), loading = _c[0], setLoading = _c[1];
    var _d = (0, react_1.useState)(null), error = _d[0], setError = _d[1];
    // handler ------------------------------------------------------------------------------------
    var handleDropdownChange = function (event) {
        event.preventDefault();
        setProductNodeId(event.target.value);
    };
    // effect -------------------------------------------------------------------------------------
    (0, react_1.useEffect)(function () {
        var getProducts = function () { return __awaiter(void 0, void 0, void 0, function () {
            var data, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // asuming always 'please select' is added at least
                        // don't fetch again if data are up-2-date
                        if (state.productDetailOptions.length > 1
                            && state.productDetailOptionsFetchedFor === state.productGroupNodeId) {
                            return [2 /*return*/];
                        }
                        // set directly without loading if empty
                        if (state.productGroupNodeId === "") {
                            setProductOptions([state.pleaseSelectOption]);
                            return [2 /*return*/];
                        }
                        // load new options
                        console.log('Fetching products for parent node:', state.productGroupNodeId);
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, (0, ProductDetailService_1.fetchProductDetails)(state.productGroupNodeId)];
                    case 2:
                        data = _a.sent();
                        console.log('Fetched data:', data);
                        setProductOptions(__spreadArray([state.pleaseSelectOption], data, true));
                        setError(null);
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        setError('Failed to fetch data');
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        getProducts();
    }, [state.productGroupNodeId]);
    return (react_1.default.createElement(DropdownStep_1.default, { id: "dropdownProductDetail", label: state.productGroupNodeId !== "" && loading ? loadingText : labelText, stepNumber: "3", isEnabled: state.productGroupNodeId !== "", options: state.productDetailOptions, selectedValue: state.productDetailNodeId, prevStatus: state.productGroupNodeId === ""
            ? DownloadStepContracts_1.DropdownStepProcessStatus.disabled
            : DownloadStepContracts_1.DropdownStepProcessStatus.enabled, nextStatus: state.productDetailNodeId === ""
            ? DownloadStepContracts_1.DropdownStepProcessStatus.disabled
            : DownloadStepContracts_1.DropdownStepProcessStatus.enabled, handleChange: handleDropdownChange }));
};
ProductDropdownStep.displayName = "Product Dropdown Step";
exports.default = ProductDropdownStep;
